import {Product} from "../model/types";

export const getTitle = (product: Product) => `${product.h1} ${product.article}`;
